{ "compressionlevel":-1,
 "height":17,
 "infinite":false,
 "layers":[
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":17,
         "id":1,
         "locked":true,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":24,
         "x":0,
         "y":0
        }, 
        {
         "id":3,
         "image":"environment.png",
         "locked":true,
         "name":"image",
         "opacity":1,
         "type":"imagelayer",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":17,
         "id":4,
         "locked":true,
         "name":"data:collision",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":24,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":2,
         "name":"data:encounters",
         "objects":[
                {
                 "height":0,
                 "id":1,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":0,
                         "y":70
                        }, 
                        {
                         "x":-70,
                         "y":70
                        }, 
                        {
                         "x":-70,
                         "y":350
                        }, 
                        {
                         "x":280,
                         "y":350
                        }, 
                        {
                         "x":280,
                         "y":140
                        }, 
                        {
                         "x":210,
                         "y":140
                        }, 
                        {
                         "x":210,
                         "y":70
                        }, 
                        {
                         "x":70,
                         "y":70
                        }, 
                        {
                         "x":70,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Alone Again"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":1
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":910,
                 "y":210
                }, 
                {
                 "height":0,
                 "id":2,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":140,
                         "y":0
                        }, 
                        {
                         "x":140,
                         "y":70
                        }, 
                        {
                         "x":210,
                         "y":70
                        }, 
                        {
                         "x":210,
                         "y":280
                        }, 
                        {
                         "x":140,
                         "y":280
                        }, 
                        {
                         "x":140,
                         "y":350
                        }, 
                        {
                         "x":70,
                         "y":350
                        }, 
                        {
                         "x":70,
                         "y":280
                        }, 
                        {
                         "x":0,
                         "y":280
                        }, 
                        {
                         "x":0,
                         "y":140
                        }, 
                        {
                         "x":-70,
                         "y":140
                        }, 
                        {
                         "x":-70,
                         "y":70
                        }, 
                        {
                         "x":0,
                         "y":70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Keep Away"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":2
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":1260,
                 "y":420
                }, 
                {
                 "height":0,
                 "id":3,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":0,
                         "y":210
                        }, 
                        {
                         "x":-70,
                         "y":210
                        }, 
                        {
                         "x":-70,
                         "y":280
                        }, 
                        {
                         "x":-140,
                         "y":280
                        }, 
                        {
                         "x":-140,
                         "y":210
                        }, 
                        {
                         "x":-210,
                         "y":210
                        }, 
                        {
                         "x":-210,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Not Enough Space"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":3
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":1190,
                 "y":630
                }, 
                {
                 "height":0,
                 "id":4,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":210,
                         "y":0
                        }, 
                        {
                         "x":210,
                         "y":-70
                        }, 
                        {
                         "x":280,
                         "y":-70
                        }, 
                        {
                         "x":280,
                         "y":-350
                        }, 
                        {
                         "x":-70,
                         "y":-350
                        }, 
                        {
                         "x":-70,
                         "y":-70
                        }, 
                        {
                         "x":0,
                         "y":-70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Tearing Hair"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":4
                        }, 
                        {
                         "name":"zoomout",
                         "type":"string",
                         "value":"1.5"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":630,
                 "y":980
                }, 
                {
                 "height":0,
                 "id":5,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":70,
                         "y":0
                        }, 
                        {
                         "x":70,
                         "y":-140
                        }, 
                        {
                         "x":0,
                         "y":-140
                        }, 
                        {
                         "x":0,
                         "y":-210
                        }, 
                        {
                         "x":-140,
                         "y":-210
                        }, 
                        {
                         "x":-140,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Never Enough Space"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":5
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":700,
                 "y":560
                }, 
                {
                 "height":0,
                 "id":6,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":0,
                         "y":350
                        }, 
                        {
                         "x":-140,
                         "y":350
                        }, 
                        {
                         "x":-140,
                         "y":280
                        }, 
                        {
                         "x":-210,
                         "y":280
                        }, 
                        {
                         "x":-210,
                         "y":210
                        }, 
                        {
                         "x":-280,
                         "y":210
                        }, 
                        {
                         "x":-280,
                         "y":70
                        }, 
                        {
                         "x":-210,
                         "y":70
                        }, 
                        {
                         "x":-210,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Gnash, the Frozen"
                        }, 
                        {
                         "name":"slug",
                         "type":"int",
                         "value":6
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":490,
                 "y":490
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":5,
         "locked":true,
         "name":"data:units",
         "objects":[
                {
                 "height":32,
                 "id":9,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"swordlord"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":280
                }, 
                {
                 "height":32,
                 "id":10,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"daggercloak"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":700
                }, 
                {
                 "height":32,
                 "id":11,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1260,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":14,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1330,
                 "y":490
                }, 
                {
                 "height":32,
                 "id":19,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":700
                }, 
                {
                 "height":32,
                 "id":20,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":700
                }, 
                {
                 "height":32,
                 "id":22,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":23,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":24,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":840,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":25,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":840,
                 "y":910
                }, 
                {
                 "height":32,
                 "id":26,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":840,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":31,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":490
                }, 
                {
                 "height":32,
                 "id":32,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":33,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":34,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":490
                }, 
                {
                 "height":32,
                 "id":35,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":36,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":37,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":280,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":40,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":490
                }, 
                {
                 "height":32,
                 "id":43,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spearknight"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":49,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":50,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":51,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":910
                }, 
                {
                 "height":32,
                 "id":52,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":980
                },
            
                {
                 "height":32,
                 "id":53,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":980
                }, 
                {
                 "height":32,
                 "id":54,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":55,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":57,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":59,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":420
                }, 
                {
                 "height":32,
                 "id":60,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":420
                }, 
                {
                 "height":32,
                 "id":61,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":280,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":62,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":210,
                 "y":630
                }, 
                {
                 "height":32,
                 "id":63,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"devil"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"devil"
                        }, 
                        {
                         "name":"isRandomized",
                         "type":"bool",
                         "value":true
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"archdevil"
                        }, 
                        {
                         "name":"maxhealth",
                         "type":"int",
                         "value":20
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":64,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":840
                }, 
                {
                 "height":32,
                 "id":65,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":630
                }, 
                {
                 "height":32,
                 "id":68,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"hammer"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":420
                }, 
                {
                 "height":32,
                 "id":69,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"highpriest"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1260,
                 "y":700
                }, 
                {
                 "height":32,
                 "id":70,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"axeknight"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":490
                }, 
                {
                 "height":32,
                 "id":73,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":630
                }, 
                {
                 "height":32,
                 "id":74,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1400,
                 "y":560
                }, 
                {
                 "height":32,
                 "id":76,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1400,
                 "y":630
                }, 
                {
                 "height":32,
                 "id":77,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"archdevil"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1330,
                 "y":770
                }, 
                {
                 "height":32,
                 "id":79,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"hammer"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":420
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":false,
         "x":0,
         "y":0
        }],
 "nextlayerid":6,
 "nextobjectid":81,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.8.6",
 "tileheight":70,
 "tilesets":[
        {
         "firstgid":1,
         "source":"..\/..\/..\/levels\/tileset.json"
        }],
 "tilewidth":70,
 "type":"map",
 "version":"1.8",
 "width":24
}